import { render } from "./JoinDetail.vue?vue&type=template&id=8eb1cb32&scoped=true"
import script from "./JoinDetail.vue?vue&type=script&lang=ts"
export * from "./JoinDetail.vue?vue&type=script&lang=ts"

import "./JoinDetail.vue?vue&type=style&index=0&id=8eb1cb32&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8eb1cb32"

export default script